import { ActionGroup, ActionItem } from '../types';
import mergeActionItems from './mergeActionItems';

function isActionGroups(arr: ActionGroup[] | ActionItem[]) {
  return arr.length > 0 && 'action_items' in arr[0];
}

export default function getCurrentActionItem(
  items: ActionGroup[] | ActionItem[],
  currentActionItemId?: string | undefined
) {
  const actionItems = isActionGroups(items)
    ? mergeActionItems(items as ActionGroup[])
    : (items as ActionItem[]);

  let currentActionItem;
  if (currentActionItemId) {
    currentActionItem = actionItems.find(
      (item: ActionItem) => item.id === currentActionItemId
    );
  } else {
    currentActionItem = actionItems.find((item: ActionItem) => !item.complete);
  }

  return currentActionItem;
}
